const optionList=[{
    value: "",
    display: "No seleccionado"
  },
  {
    value: "Embarazo, parto y puerperio",
    display: "Embarazo, parto y puerperio"
  },
  {
    value: "Ciertas afecciones originadas en el periodo perinatal",
    display: "Ciertas afecciones originadas en el periodo perinatal"
  },
  {
    value: "Ciertas enfermedades infecciosas y parasitarias",
    display: "Ciertas enfermedades infecciosas y parasitarias"
  },
  {
    value: "Códigos para propósitos especiales",
    display: "Códigos para propósitos especiales"
  },
  {
    value: "Piel y del tejido subcutáneo",
    display: "Piel y del tejido subcutáneo"
  },
  {
    value: "Sangre y de los organos hematopoyeticos, y ciertos trastornos que afectan el mecanismo de la inmunidad",
    display: "Sangre y de los organos hematopoyeticos, y ciertos trastornos que afectan el mecanismo de la inmunidad"
  },
  {
    value: "Ojo y sus anexos",
    display: "Ojo y sus anexos"
  },
  {
    value: "Oído y de la apófisis mastoides",
    display: "Oído y de la apófisis mastoides"
  },
  {
    value: "Sistema circulatorio",
    display: "Sistema circulatorio"
  },
  {
    value: "Sistema digestivo",
    display: "Sistema digestivo"
  },
  {
    value: "Sistema genitourinario",
    display: "Sistema genitourinario"
  },
  {
    value: "Sistema nervioso",
    display: "Sistema nervioso"
  },
  {
    value: "Sistema osteomuscular y del tejido conjuntivo",
    display: "Sistema osteomuscular y del tejido conjuntivo"
  },
  {
    value: "Sistema respiratorio",
    display: "Sistema respiratorio"
  },
  {
    value: "Endocrinas, nutricionales y metabólicas",
    display: "Endocrinas, nutricionales y metabólicas"
  },
  {
    value: "Factores que influyen en el estado de salud y contacto con los servicios de salud",
    display: "Factores que influyen en el estado de salud y contacto con los servicios de salud"
  },
  {
    value: "Malformaciones congénitas, deformidades y anomalías cromosómicas",
    display: "Malformaciones congénitas, deformidades y anomalías cromosómicas"
  },
  {
    value: "Neoplasias",
    display: "Neoplasias"
  },
  {
    value: "Síntomas, signos y hallazgos anormales clínicos y de laboratorio, no clasificados en otra parte",
    display: "Síntomas, signos y hallazgos anormales clínicos y de laboratorio, no clasificados en otra parte"
  },
  {
    value: "Trastornos mentales y del comportamiento",
    display: "Trastornos mentales y del comportamiento"
  },
  {
    value: "Traumatismos, envenenamiento y algunas otras consecuencias de causas externas",
    display: "Traumatismos, envenenamiento y algunas otras consecuencias de causas externas"
  }
]
  export default optionList;